import { useTranslation } from 'next-i18next';
import { FC, useEffect, useState } from 'react';

import { INSTAGRAM_LINK, INSTAGRAM_NAME } from '../../../../config';

import { InstagramContent } from './InstagramСontent';

import { Button } from '@/components/shared/Button';
import { Icons, IconsTypes } from '@/components/shared/Icons';
import { Link } from '@/components/shared/Link';
import { COMMON_LOCALE_PART } from '@/locale';
import { InstagramPost } from '@/types/types/Home';

export const InstagramModule: FC<{ feed: InstagramPost[] }> = ({ feed }) => {
  const { t } = useTranslation(COMMON_LOCALE_PART);
  const [posts, setPosts] = useState<InstagramPost[]>(feed || []);

  useEffect(() => {
    async function getInstagramFeed() {
      const request = (await import('../../../helpers/api')).default({});
      const updatedFeed = await request<InstagramPost[]>('/instagram/posts/');
      setPosts(updatedFeed?.data || []);
    }
    getInstagramFeed();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className="container">
      <div className="rounded-md bg-white p-4 md:p-8">
        <div className="mb-4 flex items-center justify-between md:mb-8">
          <div className="flex items-center space-x-2 md:space-x-4">
            <div className="rounded-full border border-black p-1">
              <div className="flex h-[37px] w-[37px] items-center justify-center rounded-full bg-black-400 md:h-[77px] md:w-[77px]">
                {Icons({ name: IconsTypes.LOGO_SMALL, iconProps: { className: 'h-[32px] md:h-[66px]' } })}
              </div>
            </div>

            <p className="max-w-xs font-bold md:max-w-xl md:text-2xl">
              {t('instagram-module.title')}
              &nbsp;
              <span className="text-green">{INSTAGRAM_NAME}</span>
            </p>
          </div>

          <Link href={INSTAGRAM_LINK} target="_blank">
            <Button type="button">{t('buttons.follow')}</Button>
          </Link>
        </div>

        <div className="relative">
          <InstagramContent posts={posts} />
        </div>
      </div>
    </section>
  );
};
